import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetUserAddresses = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Address.GetUserAddresses}?${query}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching addresses:', error);
        throw error;
    }
};

export const AddUserAddress = async (addressData) => {
    try {
        const response = await api.post(endpoints.Address.AddUserAddress, addressData);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching addresses:', error);
        throw error;
    }
};

export const UpdateUserAddress = async (addressId,addressData) => {
    try {
        const response = await api.put(`${endpoints.Address.UpdateUserAddress}?addressId=${addressId}`, addressData);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching addresses:', error);
        throw error;
    }
};

export const DeleteUserAddress = async (addressId) => {
    try {
        const response = await api.delete(`${endpoints.Address.DeleteUserAddress}?addressId=${addressId}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error deleting address:', error);
        throw error;
    }
};

export const GetAllCities = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Address.GetAllCities}?${query}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error deleting address:', error);
        throw error;
    }
};

const addressService = {
    GetUserAddresses,
    DeleteUserAddress
};

export default addressService;
